<div class="categories-container">
  <h3>Categories</h3>

  <div class="stats-card">
    <div>
      <div class="counter">{{total}}</div>
      <div class="hint">Total categories</div>

      <div class="infoline">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <path d="M4.49992 16.6667L3.33325 15.5001L12.9999 5.83341H7.49992V4.16675H15.8333V12.5001H14.1666V7.00008L4.49992 16.6667Z" fill="#00FF22"/>
        </svg>

        28

        <span>+2.1 % this week</span>
      </div>

    </div>
  </div>

  <div class="table-toolbar">
    <app-icon-input [formControl]="searchValue" placeholder="Search by name" style="width: 300px"></app-icon-input>

    <div>
      @if (selection.selected.length > 0) {
        <button matButton="filled" class="warning-button" (click)="bulkDelete()">Delete Selected</button>
      }
      <button matButton="filled" style="margin-left: 25px;" (click)="add()">Add</button>
    </div>

  </div>

  @if(store.isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="table-container mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="date" matSortDisableClear matSortDirection="desc" (matSortChange)="sortChange($event)">

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-10p"></th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row.id) : null"
            [checked]="selection.isSelected(row.id)"
          ></mat-checkbox>

        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let row"> {{row.name}} </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-15p"> Last Updated </th>
        <td mat-cell *matCellDef="let row"> {{row.updatedAt | date:'MM/dd/yyyy' }} </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-10p"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon (click)="edit(row)" class="pointer mt-5">edit</mat-icon>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 100]" [length]="total" (page)="changePage($event)" aria-label="Select page"></mat-paginator>

  </div>

</div>
